$(document).ready(function () {
  $('select[name=extra_product_id]').select2({
    theme: 'bootstrap4',
  });

  $('select[name=product_extra_template_id]').select2({
    theme: 'bootstrap4',
  });

  $(document).on(
    'input',
    '#ticket_price_ex_vat, #ticket_price_incl_vat, #degree_of_coverage, #coverage_contribution, #price-inc-mva-value, #price-ex-mva-value, #ticket_alter_price_ex_vat, #volume',
    function (event) {
      const regex = /^[0-9]*[.,]?[0-9]*$/;

      const inputValue = $(this).val();

      if (!regex.test(inputValue)) {
        $(this).val(inputValue.slice(0, -1));
      }
    }
  );

  $(document).on('change', '#printer_id', function () {
    if ($(this).prop('checked')) {
      return;
    } else {
      $('#printer-id').val('');
    }
  });

  $(document).on('change', '#is_volume', function () {
    if ($(this).prop('checked')) {
      $('#volume').prop('required', true);
      $('#volume').prop('type', 'number');
    } else {
      $('#volume').removeAttr('required');
      $('#volume').prop('type', 'hidden');
    }
  });

  let p = $('body').attr('p');
  let a = $('body').attr('a');
  let language = $('body').attr('lang');
  const menuProducts = [];
  if (p == 'organizer_event_ticket_category' && a == 'new') {
    let productExtraTemplateIdList = [];
    let productExtraTemplateList = [];
    let isProductTotalSum = false;
    let extraProductIdList = [];
    let extraProductList = [];
    let extraProductTextList = [];
    let extraProductTextListToShow = [];
    let previousMenuProductTotal = 0;
    let menuTotalProductPrice = 0;
    let degreeOfCoverage = formattedValueForNumberInput(
      $('#degree_of_coverage').val()
    );
    let coverageOfContribution = formattedValueForNumberInput(
      $('#coverage_contribution').val()
    );
    let productPrice = formattedValueForNumberInput(
      $('#ticket_price_ex_vat').val()
    );
    let mva = $('#vat_code').children('option:selected').text();
    let priceExMva = formattedValueForNumberInput(
      $('#price-ex-mva-value').val()
    );
    let priceIncMva = formattedValueForNumberInput(
      $('#price-inc-mva-value').val()
    );

    // alternative_prices
    let alterDegreeOfCoverage = formattedValueForNumberInput(
      $('#alter_degree_of_coverage').val()
    );

    let alterCoverageOfContribution = formattedValueForNumberInput(
      $('#alter_coverage_contribution').val()
    );

    let alterProductPrice = formattedValueForNumberInput(
      $('#ticket_alter_price_ex_vat').val()
    );

    let alterMva = $('#alter_vat_code').children('option:selected').text();

    let alterPriceOutExMva = formattedValueForNumberInput(
      $('#alter_price_out_ex_mva').val()
    );

    let alterPriceOutIncMva = formattedValueForNumberInput(
      $('#alter_ticket_price_out_inc_mva').val()
    );

    $(document).on('change', '#open-price', function () {
      if ($(this).is(':checked')) {
        $('#alternative_price').prop('disabled', true);
        $(this).val('1');

        $(
          '#ticket_price_ex_vat, #degree_of_coverage, #coverage_contribution, #price-ex-mva-value, #price-inc-mva-value'
        ).prop('disabled', true);
        $(
          '#ticket_alter_price_ex_vat, #alter_degree_of_coverage, #alter_coverage_contribution, #alter_price_out_ex_mva, #alter_vat_code, #alter_ticket_price_out_inc_mva'
        ).prop('disabled', true);
      } else {
        $(this).val('0');

        $('#alternative_price').prop('disabled', false);
        $(
          '#ticket_price_ex_vat, #degree_of_coverage, #coverage_contribution, #price-ex-mva-value, #price-inc-mva-value'
        ).prop('disabled', false);
        $(
          '#ticket_alter_price_ex_vat, #alter_degree_of_coverage, #alter_coverage_contribution, #alter_price_out_ex_mva, #alter_vat_code, #alter_ticket_price_out_inc_mva'
        ).prop('disabled', false);
      }
    });

    //end of alt_prices

    $(document).on('blur', '#product-sku-input', function (e) {
      e.preventDefault();
      const encodedData = $('#existing_product_number').attr(
        'data-product-number-list'
      );
      const existingNumberList = JSON.parse(atob(encodedData));
      const newValue = $(this).val();
      const oldValue = $(this).attr('data-old-value');
      const filteredexistingNumbers = existingNumberList.filter(
        (number) => number !== oldValue
      );

      if (filteredexistingNumbers.includes(newValue)) {
        alert('varenummer finnes allerede!');
        $(this).val(oldValue);
        $(this).focus();
        return;
      }
    });

    $(document).on('change', '#ticket_price_ex_vat', function (e) {
      e.preventDefault();
      productPrice = formattedValueForNumberInput($(this).val());
      const payload = {
        field: 'ticket_price_ex_vat',
        productPrice,
        priceExMva,
        priceIncMva,
        degreeOfCoverage,
        coverageOfContribution,
        mva: parseInt(mva),
      };

      $.ajax({
        type: 'POST',
        url: '/api/v1/private/products/calculate-price',
        data: payload,
        async: true,
        cache: false,
      })
        .done(function (data) {
          updateInputValues(data);
        })
        .fail(function (data) {
          console.log(data);
        });
    });

    $(document).on('change', '#degree_of_coverage', function (e) {
      e.preventDefault();

      degreeOfCoverage = formattedValueForNumberInput($(this).val());
      const payload = {
        field: 'degree_of_coverage',
        productPrice,
        priceExMva,
        priceIncMva,
        degreeOfCoverage,
        coverageOfContribution,
        mva: parseInt(mva),
      };

      $.ajax({
        type: 'POST',
        url: '/api/v1/private/products/calculate-price',
        data: payload,
        async: true,
        cache: false,
      })
        .done(function (data) {
          updateInputValues(data);
        })
        .fail(function (data) {
          console.log(data);
        });
    });

    $(document).on('change', '#coverage_contribution', function (e) {
      e.preventDefault();
      coverageOfContribution = formattedValueForNumberInput($(this).val());
      const payload = {
        field: 'coverage_contribution',
        productPrice,
        priceExMva,
        priceIncMva,
        degreeOfCoverage,
        coverageOfContribution,
        mva: parseInt(mva),
      };

      $.ajax({
        type: 'POST',
        url: '/api/v1/private/products/calculate-price',
        data: payload,
        async: true,
        cache: false,
      })
        .done(function (data) {
          updateInputValues(data);
        })
        .fail(function (data) {
          console.log(data);
        });
    });

    $(document).on('change', '#price-ex-mva-value', function (e) {
      e.preventDefault();
      priceExMva = formattedValueForNumberInput($(this).val());
      const payload = {
        field: 'price_ex_mva_value',
        productPrice,
        priceExMva,
        priceIncMva,
        degreeOfCoverage,
        coverageOfContribution,
        mva: parseInt(mva),
      };

      $.ajax({
        type: 'POST',
        url: '/api/v1/private/products/calculate-price',
        data: payload,
        async: true,
        cache: false,
      })
        .done(function (data) {
          updateInputValues(data);
        })
        .fail(function (data) {
          console.log(data);
        });
    });

    $(document).on('change', '#price-inc-mva-value', function (e) {
      e.preventDefault();
      priceIncMva = formattedValueForNumberInput($(this).val());
      const payload = {
        field: 'price_inc_mva_value',
        productPrice,
        priceExMva,
        priceIncMva,
        degreeOfCoverage,
        coverageOfContribution,
        mva: parseInt(mva),
      };

      $.ajax({
        type: 'POST',
        url: '/api/v1/private/products/calculate-price',
        data: payload,
        async: true,
        cache: false,
      })
        .done(function (data) {
          updateInputValues(data);
        })
        .fail(function (data) {
          console.log(data);
        });
    });

    $(document).on('change', '#vat_code', function (e) {
      e.preventDefault();
      isProductTotalSum = $('#is_product_total_sum').is(':checked');

      mva = $(this).children('option:selected').text();
      const payload = {
        field: 'mva',
        productPrice,
        priceExMva,
        priceIncMva,
        degreeOfCoverage,
        coverageOfContribution,
        mva: parseInt(mva),
      };

      $.ajax({
        type: 'POST',
        url: '/api/v1/private/products/calculate-price',
        data: payload,
        async: true,
        cache: false,
      })
        .done(function (data) {
          updateInputValues(data);
        })
        .fail(function (data) {
          console.log(data);
        });
    });

    // alternative Prices

    $(document).on('change', '#ticket_alter_price_ex_vat', function (e) {
      e.preventDefault();

      const alterProductPrice = formattedValueForNumberInput($(this).val());

      // Make sure these variables are defined or replace them with actual values
      const payload = {
        field: 'ticket_alter_price_ex_vat',
        alterProductPrice,
        alterPriceOutExMva,
        alterPriceOutIncMva,
        alterDegreeOfCoverage,
        alterCoverageOfContribution,
        alterMva: parseInt(alterMva),
      };

      $.ajax({
        type: 'POST',
        url: '/api/v1/private/products/calculate-alter-price',
        data: payload,
        async: true,
        cache: false,
      })
        .done(function (data) {
          updateAlterInputValues(data);
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
          console.error(' API Error:', textStatus, errorThrown);
          console.log('Response Text:', jqXHR.responseText);
        });
    });

    $(document).on('change', '#alter_degree_of_coverage', function (e) {
      e.preventDefault();

      alterDegreeOfCoverage = formattedValueForNumberInput($(this).val());
      const payload = {
        field: 'alter_degree_of_coverage',
        alterProductPrice,
        alterPriceOutExMva,
        alterPriceOutIncMva,
        alterDegreeOfCoverage,
        alterCoverageOfContribution,
        alterMva: parseInt(alterMva),
      };

      $.ajax({
        type: 'POST',
        url: '/api/v1/private/products/calculate-alter-price',
        data: payload,
        async: true,
        cache: false,
      })
        .done(function (data) {
          updateAlterInputValues(data);
        })
        .fail(function (data) {
          console.log(data);
        });
    });

    $(document).on('change', '#alter_coverage_contribution', function (e) {
      e.preventDefault();
      alterCoverageOfContribution = formattedValueForNumberInput($(this).val());
      const payload = {
        field: 'alter_coverage_contribution',
        alterProductPrice,
        alterPriceOutExMva,
        alterPriceOutIncMva,
        alterDegreeOfCoverage,
        alterCoverageOfContribution,
        alterMva: parseInt(alterMva),
      };

      $.ajax({
        type: 'POST',
        url: '/api/v1/private/products/calculate-alter-price',
        data: payload,
        async: true,
        cache: false,
      })
        .done(function (data) {
          updateAlterInputValues(data);
        })
        .fail(function (data) {
          console.log(data);
        });
    });

    $(document).on('change', '#alter_price_out_ex_mva', function (e) {
      e.preventDefault();
      alterPriceOutExMva = formattedValueForNumberInput($(this).val());
      const payload = {
        field: 'alter_price_out_ex_mva',
        alterProductPrice,
        alterPriceOutExMva,
        alterPriceOutIncMva,
        alterDegreeOfCoverage,
        alterCoverageOfContribution,
        alterMva: parseInt(alterMva),
      };

      $.ajax({
        type: 'POST',
        url: '/api/v1/private/products/calculate-alter-price',
        data: payload,
        async: true,
        cache: false,
      })
        .done(function (data) {
          updateAlterInputValues(data);
        })
        .fail(function (data) {
          console.log(data);
        });
    });

    $(document).on('change', '#alter_ticket_price_out_inc_mva', function (e) {
      e.preventDefault();
      alterPriceOutIncMva = formattedValueForNumberInput($(this).val());
      const payload = {
        field: 'alter_ticket_price_out_inc_mva',
        alterProductPrice,
        alterPriceOutExMva,
        alterPriceOutIncMva,
        alterDegreeOfCoverage,
        alterCoverageOfContribution,
        alterMva: parseInt(alterMva),
      };

      $.ajax({
        type: 'POST',
        url: '/api/v1/private/products/calculate-alter-price',
        data: payload,
        async: true,
        cache: false,
      })
        .done(function (data) {
          updateAlterInputValues(data);
        })
        .fail(function (data) {
          console.log(data);
        });
    });

    $(document).on('change', '#alter_vat_code', function (e) {
      e.preventDefault();
      isProductTotalSum = $('#is_product_total_sum').is(':checked');

      alterMva = $(this).children('option:selected').text();
      const payload = {
        field: 'alter_mva',
        alterProductPrice,
        alterPriceOutExMva,
        alterPriceOutIncMva,
        alterDegreeOfCoverage,
        alterCoverageOfContribution,
        alterMva: parseInt(alterMva),
      };

      $.ajax({
        type: 'POST',
        url: '/api/v1/private/products/calculate-alter-price',
        data: payload,
        async: true,
        cache: false,
      })
        .done(function (data) {
          updateAlterInputValues(data);
        })
        .fail(function (data) {
          console.log(data);
        });
    });

    // end of alternative_prices

    $(document).on(
      'click',
      '#product-extra-from-template-register-button',
      function () {
        let productExtraTemplateId = $('#product_extra_template_id').val();
        let productExtraTemplateName = $(
          '#product_extra_template_id option:selected'
        ).text();
        $('#product_extra_template_id').select2({ theme: 'bootstrap4' });
        let selectedValue = $('#product_extra_template_id').val();

        // Hide the selected option
        $(
          "#product_extra_template_id option[value='" + selectedValue + "']"
        ).prop('disabled', true);

        // Select the next visible option
        let options = $('#product_extra_template_id option:not(:disabled)');
        if (options.length > 0) {
          let nextOption = $(options[0]);
          nextOption.prop('selected', true);
        }

        // Refresh Select2
        $('#product_extra_template_id').trigger('change');
        if (
          $.inArray(productExtraTemplateId, productExtraTemplateIdList) ===
            -1 &&
          productExtraTemplateId !== null &&
          productExtraTemplateId != 0
        ) {
          productExtraTemplateIdList.push(productExtraTemplateId);

          $.ajax({
            type: 'POST',
            url: '/ajax/organizer_event_ticket_category/get_product_extra',
            data: { id: productExtraTemplateId },
          }).done(function (data) {
            data.map(function (item) {
              productExtraTemplateList.push({
                id: item.id,
                name: item.name ? item.name : item.extra_text,
              });
            });

            popupAlert();
            showSelectedExtraProduct();
          });
        }
      }
    );

    $(document).on('click', '#product-extra-register-button', function () {
      let extraProductId = $('#extra_product_id').val();
      let extraProdcutName = $('#extra_product_id option:selected').text();

      // Refresh Select2
      $('#extra_product_id').trigger('change');
      $('#extra_product_id').select2({ theme: 'bootstrap4' });
      if (
        $.inArray(extraProductId, extraProductIdList) === -1 &&
        extraProductId !== null &&
        extraProductId != 0
      ) {
        let selectedValue = $('#extra_product_id').val();

        // Hide the selected option
        $("#extra_product_id option[value='" + selectedValue + "']").prop(
          'disabled',
          true
        );
        $("#extra_product_id option[value='" + selectedValue + "']").addClass(
          'hidden'
        );

        // Select the next visible option
        let options = $('#extra_product_id option:not(:disabled)');
        if (options.length > 0) {
          let nextOption = $(options[0]);
          nextOption.prop('selected', true);
        }
        extraProductIdList.push(extraProductId);
        extraProductList.push({
          id: extraProductId,
          name: extraProdcutName,
        });
        showSelectedExtraProduct();
      } else {
        return;
      }
    });

    let i = 1;
    $(document).on('click', '#extra-product-text-add-button', function () {
      let extraProductText = $('#extra-product-text').val();
      if (
        extraProductText !== '' &&
        !extraProductTextList.includes(extraProductText)
      ) {
        extraProductTextList.push(extraProductText);
        extraProductTextListToShow.push({ id: i, name: extraProductText });
        i++;
        showSelectedExtraProduct();
      }
      $('#extra-product-text').val('');
      $('#collapse-extra-product-text').collapse('hide');
    });

    $(document).on('click', '.product-extra-delete-button', function () {
      let productId = $(this).attr('data-product-id');
      let productType = $(this).attr('data-product-type');
      if (productType === 'extra') {
        extraProductIdList = $.grep(extraProductIdList, function (id) {
          return id !== productId;
        });
        extraProductList = $.grep(extraProductList, function (item) {
          return item.id !== productId;
        });

        $("#extra_product_id option[value='" + productId + "']").prop(
          'disabled',
          false
        );
      } else if (productType === 'extra-template') {
        productExtraTemplateList = $.grep(
          productExtraTemplateList,
          function (item) {
            return item.id != productId;
          }
        );
        productExtraTemplateIdList = $.grep(
          productExtraTemplateIdList,
          function (item) {
            return item != productId;
          }
        );
        $("#product_extra_template_id option[value='" + productId + "']").prop(
          'disabled',
          false
        );
      } else {
        let productName = $(this).attr('data-product-name');
        extraProductTextList = $.grep(extraProductTextList, function (text) {
          return text !== productName;
        });
        extraProductTextListToShow = $.grep(
          extraProductTextListToShow,
          function (item) {
            return item.id != productId;
          }
        );
        $("#product_extra_template_id option[value='" + productId + "']").prop(
          'disabled',
          false
        );
      }
      showSelectedExtraProduct();
    });

    $(document).on('submit', '#choose-product-search-form', function (e) {
      e.preventDefault();
      let search_string = $('#choose_product_search_string').val();
      let location_id = $('body').attr('event_id');
      let product_type = 0;

      getProductList(location_id, search_string, product_type);
    });

    $(document).on('click', '#is_product_total_sum', function () {
      isProductTotalSum = $('#is_product_total_sum').is(':checked');
      const removeButtons = $('.remove-menu-product');
      const amountInputs = $('.amount-input');
      const existingProductPrice = $('#ticket_price_ex_vat').attr(
        'data-old-value'
      );
      const existingProductPriceExVat = $('#price-ex-mva-value').attr(
        'data-old-value'
      );
      const existingProductPriceIncVat = $('#price-inc-mva-value').attr(
        'data-old-value'
      );
      const existingProductDB = $('#coverage_contribution').attr(
        'data-old-value'
      );
      const existingProductDG = $('#degree_of_coverage').attr('data-old-value');
      const existingVAT = $('#vat_code').attr('data-old-value');

      if (isProductTotalSum) {
        removeButtons.removeClass('disabled').prop('disabled', false);
        amountInputs.removeClass('disabled').prop('disabled', false);
        calculateMenuProductTotalSum(menuProducts);
      } else {
        // Pass a callback function to handle the result
        calculateMenuProductTotalSum(
          menuProducts,
          'get_current_total_menu_product_price',
          function (totalPrice) {
            menuTotalProductPrice = totalPrice;
            productPrice = productPrice - menuTotalProductPrice;
            productPrice = productPrice.toFixed(2).replace('.', ',');
            $('#ticket_price_ex_vat').val(productPrice || '');
            $('#price-ex-mva-value').val(existingProductPriceExVat || '');
            $('#price-inc-mva-value').val(existingProductPriceIncVat || '');
            $('#degree_of_coverage').val(degreeOfCoverage || '1');
            $('#coverage_contribution').val(existingProductDB || '');
            if (
              degreeOfCoverage === null ||
              degreeOfCoverage === undefined ||
              degreeOfCoverage === ''
            ) {
              degreeOfCoverage = 0;
            }
            $('#degree_of_coverage').trigger('change');
            previousMenuProductTotal = 0;
          }
        );
      }
    });

    $(document).on('click', '.menu-product-item', function () {
      isProductTotalSum = $('#is_product_total_sum').is(':checked');
      const productName = $(this).data('menu-product-name');
      const productId = $(this).attr('id');
      const isProductVolume = $(this).data('is-menu-product-volume');
      const productVolume = $(this).data('menu-product-volume');
      const tableBody = $('#menu-product-table-body');

      // Check if product already exists in the table
      const existingRow = $(`#menu-product-${productId}`);

      if (existingRow.length > 0) {
        // Product already exists, update the amount
        const amountInput = existingRow.find('.amount-input');
        const currentAmount =
          parseFloat(amountInput.val().replace(',', '.')) || 0;
        const newAmount = currentAmount + 1;
        if (productVolume < newAmount && isProductVolume == 'L') {
          alert('Maksimal mengde for denne varen er ' + productVolume + ' L');
          amountInput.val(currentAmount);
          return;
        }
        amountInput.val(newAmount);

        // Update the menuProducts array
        const existingProduct = menuProducts.find(
          (p) => p.product_id === productId
        );
        if (existingProduct) {
          existingProduct.amount = newAmount;
        }

        // Show a brief notification (optional)
        // You can uncomment this if you want to show user feedback
        // alert(`${productName} amount updated to ${newAmount}`);
      } else {
        // Product doesn't exist, add new row
        const menuProduct = {
          product_id: productId,
          name: productName,
          amount: isProductVolume == 'L' ? productVolume : 1,
        };

        const newRow = `
              <tr id="menu-product-${productId}">
                  <td class="name-column">${productName}</td>
                  <td>
                      <div class="input-group">
                          <input type="number" data-product-id="${productId}" data-menu-product-volume="${productVolume}" data-is-menu-product-volume="${isProductVolume}" class="form-control amount-input" value="${
                            isProductVolume == 'L' ? productVolume : 1
                          }" min="0" step="any"
                              onfocus="this.select()">
                          <div class="input-group-append">
                              <span class="input-group-text">${isProductVolume}</span>
                          </div>
                      </div>
                  </td>
                  <td class="text-center">
                      <button type="button" data-menu-product-id="${productId}" class="btn btn-danger btn-sm remove-menu-product">${
                        language === 'no' ? 'Fjerne' : 'Remove'
                      }</button>
                  </td>
              </tr>
          `;

        tableBody.append(newRow);
        menuProducts.push(menuProduct);
      }

      $('#choose-product-modal').modal('hide');

      if (isProductTotalSum) {
        calculateMenuProductTotalSum(menuProducts);
      }
    });

    $(document).on('change', '.amount-input', function () {
      let value = parseFloat(this.value) || 0;
      const productId = $(this).data('product-id');
      const productVolume = $(this).data('menu-product-volume') || 0;
      const isProductVolume = $(this).data('is-menu-product-volume');
      isProductTotalSum = $('#is_product_total_sum').is(':checked');
      if (isProductVolume === 'L') {
        if (value <= 0) {
          alert('Mengden bør være større enn null!');
          value = 0.1;
        }
        $(this).val(value);
      } else {
        if (value <= 0) {
          alert('Mengden bør være større enn null!');
          value = 0.1;
        }
        $(this).val(value);
      }
      const index = menuProducts.findIndex(
        (product) => product.product_id == productId
      );

      if (index !== -1) {
        menuProducts[index].amount = value;
      }

      if (isProductTotalSum) {
        calculateMenuProductTotalSum(menuProducts);
      }
    });

    $(document).on('click', '.remove-menu-product', function (e) {
      e.preventDefault();
      const productId = $(this).data('menu-product-id');
      isProductTotalSum = $('#is_product_total_sum').is(':checked');
      $(this).closest('tr').remove();

      const index = menuProducts.findIndex(
        (product) => product.product_id == productId
      );

      if (index !== -1) {
        menuProducts.splice(index, 1);
      }

      if (isProductTotalSum) {
        calculateMenuProductTotalSum(menuProducts);
      }
    });

    $(document).on('change', '#is_menu_product', function () {
      if ($(this).is(':checked')) {
        $('#choose-product-button').show();
      } else {
        $('#choose-product-button').hide();
      }
    });

    if (
      $('#event_ticket_category_id').val() === undefined ||
      $('#event_ticket_category_id').val() == null ||
      $('#event_ticket_category_id').val() === ''
    ) {
      let event_ticket_category_new_ajax_lock = false;

      $(document).on('submit', '#event_ticket_category_form', function (e) {
        e.preventDefault();
        isProductTotalSum = $('#is_product_total_sum').is(':checked');
        if (!event_ticket_category_new_ajax_lock) {
          let event_id = $('#event_id').val();
          let product_type = parseInt($('#product_type').val());

          event_ticket_category_new_ajax_lock = true;

          $(':disabled').each(function () {
            $(this).removeAttr('disabled');
          });

          let formData = new FormData(
            document.getElementById('event_ticket_category_form')
          );
          if (extraProductIdList.length > 0) {
            formData.append('extraProductIdList', extraProductIdList);
          }
          if (extraProductTextList.length > 0) {
            formData.append('extraProductTextList', extraProductTextList);
          }
          if (productExtraTemplateIdList.length > 0) {
            formData.append(
              'productExtraTemplateIdList',
              productExtraTemplateIdList
            );
          }
          let productCategoryPOSIds = formData.getAll('product-category-pos');
          let productCategorySelfServiceIds = formData.getAll(
            'product-category-self-service'
          );
          if (productCategoryPOSIds.length > 0) {
            formData.append('product_category_pos_list', productCategoryPOSIds);
          }
          if (productCategorySelfServiceIds.length > 0) {
            formData.append(
              'product_category_self_service_list',
              productCategorySelfServiceIds
            );
          }
          if (menuProducts.length > 0) {
            formData.append('menu_products', JSON.stringify(menuProducts));
          }
          console.log(JSON.stringify(formData));
          const disabledOnClick = $('#event_ticket_category_button');
          const btnWidth = disabledOnClick.outerWidth();
          disabledOnClick.css('width', btnWidth + 'px');
          disabledOnClick.prop('disabled', true);
          disabledOnClick.html(
            '<i class="spinner-border spinner-border-sm"></i>'
          );
          $.ajax({
            type: 'POST',
            url: '/ajax/organizer_event_ticket_category/new',
            data: formData,
            enctype: 'multipart/form-data',
            async: true,
            cache: false,
            processData: false,
            contentType: false,
          })
            .done(function (data) {
              disabledOnClick.prop('disabled', false);
              disabledOnClick.html('Lagre');
              try {
                // Check if data is already a JSON object
                if (typeof data === 'string') {
                  data = JSON.parse(data); // Attempt to parse it if it's a string
                }
              } catch (error) {}

              if (
                !data.error &&
                data.message !== undefined &&
                data.message !== null &&
                data.product_id !== undefined &&
                data.product_id !== null
              ) {
                prependAlert('#product_msg', data.message, 'success', null);
                $('#event_ticket_category_form').hide();
                $('.card-box-to-hide').hide();
                $('#event_ticket_category_button').hide();

                const params = new URLSearchParams(window.location.search);
                const page = params.get('page');

                setTimeout(function () {
                  if (product_type === 0) {
                    document.location.href =
                      '/location/' +
                      event_id +
                      '/product' +
                      (page ? '?page=' + page : '') +
                      (data.not_connected_external_account_plan
                        ? '&product_warning=' +
                          data.not_connected_external_account_plan_message
                        : '');
                  } else {
                    document.location.href =
                      '/location/' +
                      event_id +
                      '/product/extra' +
                      (page ? '?page=' + page : '') +
                      (data.not_connected_external_account_plan
                        ? '&product_warning=' +
                          data.not_connected_external_account_plan_message
                        : '');
                  }
                }, 2000);
              }
            })
            .fail(function (data, jqXHR, textStatus, errorThrown) {
              disabledOnClick.prop('disabled', false);
              disabledOnClick.html('Lagre');

              if (
                data.error &&
                data.message !== undefined &&
                data.message !== null
              ) {
                prependAlert('#product_msg', data.message, 'danger', null);
              }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
              // alert("Product Failure=======>" + JSON.stringify(jqXHR.responseText));
              // Check for redirect URL
              if (
                jqXHR.responseJSON &&
                jqXHR.responseJSON.redirect_url !== undefined &&
                jqXHR.responseJSON.redirect_url !== null
              ) {
                document.location.href = jqXHR.responseJSON.redirect_url;
              }

              let message = extractErrorMessage(jqXHR);

              prependAlert('#product_msg', message, 'danger', null);

              // This check might not work as expected since jqXHR doesn't have .error property
              // You might want to remove this or check jqXHR.responseJSON instead
              if (
                jqXHR.responseJSON &&
                jqXHR.responseJSON.error &&
                jqXHR.responseJSON.message !== undefined &&
                jqXHR.responseJSON.message !== null
              ) {
                prependAlert(
                  '#product_msg',
                  jqXHR.responseJSON.message,
                  'danger',
                  null
                );
              }

              event_ticket_category_new_ajax_lock = false;
            })
            .always(function () {
              event_ticket_category_new_ajax_lock = false;
            });
        }

        return false;
      });
    }

    function extractErrorMessage(jqXHR) {
      let message = 'Something went wrong.';

      try {
        // Get the response text
        const responseText = jqXHR.responseText;

        // Use regex to find JSON objects in the response
        const jsonPattern = /\{[^{}]*"error_message"[^{}]*\}/g;
        const matches = responseText.match(jsonPattern);

        if (matches && matches.length > 0) {
          // Take the last match (most likely the relevant one)
          const jsonString = matches[matches.length - 1];
          const parsed = JSON.parse(jsonString);

          if (parsed.error_message) {
            message = parsed.error_message;
          }
        }
      } catch (e) {
        console.error('JSON parse failed:', e);
      }
      return message;
    }

    function showSelectedExtraProduct() {
      $('#product-extra-list-sortable').empty();
      let htmlToRender = '';
      $.map(extraProductList, function (item) {
        let productId = item.id;
        let productName = item.name;
        let htmlString = `<li class="list-group-item d-flex justify-content-between align-items-center product-extra"><div>${productName}</div>
        <span data-product-id=${productId} data-product-type="extra" class="product-extra-delete-button">
            <i class="material-icons">
                delete
            </i>
        </span>
        </li>`;

        htmlToRender += htmlString;
      });
      $.map(extraProductTextListToShow, function (item) {
        let productId = item.id;
        let productName = item.name;
        let htmlString = `<li class="list-group-item d-flex justify-content-between align-items-center product-extra">
        <div>${productName}</div>
        <span data-product-id=${productId} data-product-type="text" data-product-name=${productName} class="product-extra-delete-button">
            <i class="material-icons">
                delete
            </i>
        </span>
    </li>`;

        htmlToRender += htmlString;
      });
      $.map(productExtraTemplateList, function (item) {
        let productId = item.id;
        let productName = item.name;
        let htmlString = `<li class="list-group-item d-flex justify-content-between align-items-center product-extra">
        <div>${productName}</div>
        <span data-product-id=${productId} data-product-type="extra-template" class="product-extra-delete-button">
            <i class="material-icons">
                delete
            </i>
        </span>
    </li>`;

        htmlToRender += htmlString;
      });
      $('#product-extra-list-sortable').html(htmlToRender);
      popupAlert();
    }

    function getProductList(location_id, search_string, product_type) {
      $.ajax({
        type: 'POST',
        url: '/ajax/organizer_event_ticket_category/menu_product_search',
        data: {
          location_id,
          search_string,
          product_type,
        },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            $('#choose-product-list-container').empty();
            $('#choose-product-list-container').append(data.html);
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }

    function calculateMenuProductTotalSum(menuProducts = [], type, callback) {
      if (menuProducts.length === 0) {
        updateInputValues(
          { productPrice: productPrice },
          'menu_product_update'
        );
        if (callback) callback(0);
        return;
      }
      $.ajax({
        type: 'POST',
        url: '/api/v1/private/products/calculate-menu-prodcut-price',
        data: { menuProducts },
        async: true,
        cache: false,
      })
        .done(function (data) {
          if (
            type !== undefined &&
            type !== null &&
            type === 'get_current_total_menu_product_price'
          ) {
            if (callback) callback(data.totalProductPrice);
            return;
          }
          updateInputValues(data, 'menu_product_update');
        })
        .fail(function (data) {
          console.log(data);
          if (callback) callback(0);
        });
    }

    function updateInputValues(data, type) {
      if (type !== null && type !== '' && type === 'menu_product_update') {
        //old-initial-price + final-menu-product-price
        const existingProductPrice = $('#ticket_price_ex_vat').val() || 0;
        const existingProductPriceFloat = parseFloat(
          existingProductPrice.toString().replace(',', '.')
        );
        const menuProductPrice = data.totalProductPrice || 0;
        const newItemsPrice = menuProductPrice - previousMenuProductTotal;
        previousMenuProductTotal = menuProductPrice;
        const newMenuProductPrice =
          existingProductPriceFloat + parseFloat(newItemsPrice);
        const formattedPrice = newMenuProductPrice.toFixed(2).replace('.', ',');
        $('#ticket_price_ex_vat').val(formattedPrice);
        productPrice = newMenuProductPrice.toFixed(2);
        if (
          degreeOfCoverage === null ||
          degreeOfCoverage === undefined ||
          degreeOfCoverage === ''
        ) {
          degreeOfCoverage = 0;
        }
        $('#degree_of_coverage').trigger('change');
        return;
      }

      if (
        data.productPrice !== undefined &&
        data.productPrice !== null &&
        data.priceExMva !== undefined &&
        data.priceExMva !== null &&
        data.priceIncMva !== undefined &&
        data.priceIncMva !== null &&
        data.degreeOfCoverage !== undefined &&
        data.degreeOfCoverage !== null &&
        data.coverageOfContribution !== undefined &&
        data.coverageOfContribution !== null &&
        data.mva !== undefined &&
        data.mva !== null
      ) {
        priceExMva = data.priceExMva;
        priceIncMva = data.priceIncMva;
        degreeOfCoverage = data.degreeOfCoverage;
        coverageOfContribution = data.coverageOfContribution;
        mva = data.mva;
        productPrice = data.productPrice;
        $('#coverage_contribution').val(
          data.coverageOfContribution.toString().replace('.', ',')
        );
        $('#price-ex-mva-value').val(
          data.priceExMva.toString().replace('.', ',')
        );
        $('#price-inc-mva-value').val(
          data.priceIncMva.toString().replace('.', ',')
        );
        $('#ticket_price_ex_vat').val(
          data.productPrice.toString().replace('.', ',')
        );
        $('#degree_of_coverage').val(
          data.degreeOfCoverage.toString().replace('.', ',')
        );
        $('#vat_code option').each(function () {
          if ($(this).text() == mva) {
            $(this).prop('selected', true);
            $('#vat_code').trigger('change');
          }
        });
      }
    }

    function updateAlterInputValues(data) {
      if (
        data.alterProductPrice !== undefined &&
        data.alterProductPrice !== null &&
        data.alterPriceOutExMva !== undefined &&
        data.alterPriceOutExMva !== null &&
        data.alterPriceOutIncMva !== undefined &&
        data.alterPriceOutIncMva !== null &&
        data.alterDegreeOfCoverage !== undefined &&
        data.alterDegreeOfCoverage !== null &&
        data.alterCoverageOfContribution !== undefined &&
        data.alterCoverageOfContribution !== null &&
        data.alterMva !== undefined &&
        data.alterMva !== null
      ) {
        alterProductPrice = data.alterProductPrice;
        alterPriceOutExMva = data.alterPriceOutExMva;
        alterPriceOutIncMva = data.alterPriceOutIncMva;
        alterDegreeOfCoverage = data.alterDegreeOfCoverage;
        alterCoverageOfContribution = data.alterCoverageOfContribution;
        alterMva = data.alterMva;

        $('#alter_coverage_contribution').val(
          data.alterCoverageOfContribution.toString().replace('.', ',')
        );
        $('#alter_price_out_ex_mva').val(
          data.alterPriceOutExMva.toString().replace('.', ',')
        );
        $('#alter_ticket_price_out_inc_mva').val(
          data.alterPriceOutIncMva.toString().replace('.', ',')
        );
        $('#ticket_alter_price_ex_vat').val(
          data.alterProductPrice.toString().replace('.', ',')
        );
        $('#alter_degree_of_coverage').val(
          data.alterDegreeOfCoverage.toString().replace('.', ',')
        );
        $('#alter_vat_code option').each(function () {
          if ($(this).text() == alterMva) {
            $(this).prop('selected', true);
            $('#alter_vat_code').trigger('change');
          }
        });
      }
    }
  }

  function clearAlterInputValues() {
    // Clear the values of the relevant input fields
    $('#ticket_alter_price_ex_vat').val('');
    $('#alter_degree_of_coverage').val('');
    $('#alter_coverage_contribution').val('');
    $('#alter_price_out_ex_mva').val('');
    $('#alter_ticket_price_out_inc_mva').val('');
    $('#alter_vat_code').val('');
  }

  $(document).on('change', '#alternative_price', function (e) {
    if (!$(this).is(':checked')) {
      clearAlterInputValues();
    }
  });
  $(document).on('change', '#product_name', function (e) {
    e.preventDefault();
    const productName = $(this).val() ?? '';
    const location_id = $('body').attr('event_id');
    const productId = $('#event_ticket_category_id').val() ?? null;

    const payload = {
      productName: productName,
      locationId: location_id,
      productId: productId,
    };
    $.ajax({
      type: 'POST',
      url: '/api/v1/private/products/check-existing-product',
      data: payload,
      async: true,
      cache: false,
    })
      .done(function (data) {
        if (data.existName) {
          alert('Produktnavnet finnes allerede!');
          $('#product_name').val($('#product_name').attr('value'));
          $('#product_name').focus();
        }
      })
      .fail(function (data) {
        console.log(data);
      });
  });

  if (p === 'organizer_event_ticket_category' && a === 'list') {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const productWarning = urlParams.get('product_warning');
    if (productWarning) {
      showToast({
        message: productWarning,
        type: 'warning',
        timeout: 5000,
      });
      //remove only product_warning from url
      const params = new URLSearchParams(queryString);
      params.delete('product_warning');
      window.history.replaceState(
        {},
        '',
        window.location.pathname + '?' + params.toString()
      );
    }
  }
});
